import React, { useEffect, useState, useRef } from "react";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import NewsLetter from "../../../services/news.letter.service";
// Import Breadcrumb
import Breadcrumbs from "../../../components/Layout/Breadcrumb";
// Import DeleteModal
import DeleteModal from "../../../components/Common/DeleteModal";
// Import DataTable
import DataTable from "../../../components/Common/DataTable";
import { getDataTableQuery } from "../../../helpers/functions_helper";
import newsLetterService from "../../../services/news.letter.service";
import ViewTemplate from "./ViewTemplate";
import Drawer from "../../../components/Drawer";
import Schedule from "./Schedule";
import { getUserProfile } from "../../../helpers/functions_helper";
import { useTranslation } from "react-i18next";



const NewsLetterList = (props: any) => {
  document.title = "News Letter List | " + process.env.REACT_APP_NAME;
  const toastId = useRef(null) as any;
  const userProfile = getUserProfile("news-letter");
  const [loading, setLoading] = useState(true);
  const [loadingListData, setLoadingListData] = useState(true);
  const [newsLetterListData, setNewsLetterListData] = useState([]);
  const [deleteNewsLetter, setDeleteNewsLetter] = useState<any>({});
  const [recordName, setRecordName] = useState("");
  const [deleteModal, setDeleteModal] = useState(false);

  const [openTemplateViewer, setOpenTemplateViewer] = useState(false);
  const [scheduleBox, setScheduleBox] = useState(false);
  const [templateID, setTemplateID] = useState<any>({});
  const { t } = useTranslation();
  // DataTable ----------------------------------------------
  function renderHeaderHTML(column: any, colIndex: any) {
    return <span dangerouslySetInnerHTML={{ __html: column.text }} />;
  }

  const breadcrumbItems = [
    {
      url: "/dashboard",
      label: t("Dashboard"),
      active: false,
    },
    {
      url: "#",
      label: t("News Letter List"),
      active: true,
    },
  ];

  const columns = [
    {
      dataField: "DT_RowIndex",
      text: t("Sr. No."),
      sort: false,
      search: false,
      classes: "fix-col-left",
      headerClasses: "fix-col-left",
      headerStyle: { width: "155px" },
      style: { width: "155px" },
    },
    {
      dataField: "title",
      text: t("Name"),
      sort: true,
      search: true,
    },
    {
      dataField: "from",
      text: t("From"),
      headerFormatter: renderHeaderHTML,
      sort: true,
      search: true,
    },
    // {
    //   dataField: "applies_to",
    //   text: "Next Schedule",
    //   headerFormatter: renderHeaderHTML,
    //   sort: true,
    //   search: true,
    //   formatter: (rowContent: any, row: any): any => {
    //     return (
    //       <>
    //         {row.to && row.to.map((item: any) => <a className="badge bg-primary bg-soft text-primary font-size-11 me-1" href="#">{item.value}</a>)}
    //       </>
    //     )
    //   }
    // },
    // {
    //   dataField: "attachment",
    //   text: "Attachment",
    //   headerFormatter: renderHeaderHTML,
    //   sort: true,
    //   search: true,
    // },
    {
      dataField: "action",
      text: t("Action"),
      sort: false,
      search: false,
      formatter: (rowContent: any, row: any): any => {
        return (
          <div className="d-flex gap-2 text-end">
            {userProfile.CAN_CREATE ? <Link
              className="btn btn-pill btn-outline-primary btn-sm"
              to="#"
              onClick={() => handleDuplicateNewsLetter(row)}>
              <i className="fa-regular fa-copy"></i>{" "}{t("Duplicate")}
            </Link> : null}
            {userProfile.CAN_EDIT ? <Link
              className="btn btn-pill btn-outline-primary btn-sm"
              to={`/masters/news-letter/edit/${row.id}/${row.news_letter_id}`}
            >
              <i className="fa-regular fa-pen-to-square"></i>{" "}{t("Edit")}
            </Link> : null}
            {userProfile.CAN_CREATE ? <Link
              className="btn btn-pill btn-outline-primary btn-sm"
              to="#"
              onClick={() => scheduleMail(row)}>
              <i className="fa fa-calendar" aria-hidden="true"></i>{" "}{t("Schedule Mail")}
            </Link> : null}
            {(userProfile.CAN_VIEW && userProfile.USER_ID === parseInt(row.created_by) || userProfile.CAN_VIEW_ALL) ? <Link
              className="btn btn-pill btn-outline-primary btn-sm"
              to="#"
              onClick={() => viewMail(row)}>
              <i className="fa fa-eye" aria-hidden="true"></i>{" "}{t("View")}
            </Link> : null}
            {(userProfile.CAN_DELETE && userProfile.USER_ID === parseInt(row.created_by) || userProfile.CAN_DELETE_ALL)  ? <Link
              className="btn btn-pill btn-outline-danger btn-sm"
              to="#"
              onClick={() => onClickDelete(row)}>
              <i className="fa-regular fa-trash-can"></i>
            </Link> : null}
          </div>
        );
      },
    },
  ];

  const [datatableOptions, setDatatableOptions] = useState({
    draw: 1,
    page: 1,
    recordsTotal: 0,
    recordsFiltered: 0,
    sizePerPage: 20,
    searchText: "",
    sortField: "id",
    sortOrder: "desc",
  });

  const onTableChange = (type: any, newState: any) => {
    let draw = datatableOptions.draw + 1;
    let page = 1;
    if (type == "search") {
      page = 1;
    } else {
      page = newState.page;
    }
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: draw,
      page: page,
      sizePerPage: newState.sizePerPage,
      searchText: newState.searchText,
      sortField: newState.sortField,
      sortOrder: newState.sortOrder,
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };

  const clearFilter = () => {
    const updatedDatatableOptions = {
      ...datatableOptions,
      draw: 1,
      page: 1,
      sizePerPage: 20,
      searchText: "",
      sortField: "id",
      sortOrder: "desc",
    };
    setDatatableOptions(updatedDatatableOptions);
    setLoadingListData(true);
  };

  const getNewsLetterList = async () => {
    const res = await NewsLetter.getAll(getDataTableQuery(datatableOptions, columns));
    if (res.data.status === "success") {
      setNewsLetterListData(res.data.data);
      setDatatableOptions((preState)=>({
        ...preState,
        recordsTotal: res.data.recordsTotal,
        recordsFiltered: res.data.recordsFiltered,
      }));
      setLoadingListData(false);
      setLoading(false);
    } else {
      setNewsLetterListData([]);
      setLoadingListData(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loadingListData === true) {
      getNewsLetterList();
    }
  }, [loadingListData]);
  // Datatable -------------------------------------------------


  // Master Form --------------------------------------------------------
  const handleDuplicateNewsLetter = async (data: any) => {
    setLoading(true);
    toastId.current = toast(t("Creating duplicate news letter")+"...", {
      autoClose: false,
      isLoading: true,
    });
    try {
      const res = (await NewsLetter.duplicate(data)) as any;
     
      if (res.status === "success") {
        toast.update(toastId.current, {
          type: toast.TYPE.SUCCESS,
          render: t("Duplicate news letter created successfully"),
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setLoadingListData(true);
        getNewsLetterList();
        setLoading(false);
      } else {
        toast.update(toastId.current, {
          type: toast.TYPE.ERROR,
          render: t("Something went wrong."),
          autoClose: 5000,
          isLoading: false,
          delay: 500,
        });
        setDeleteModal(false);
        setLoadingListData(false);
        setLoading(false);
      }
    } catch (err) {
     
      toast.update(toastId.current, {
        type: toast.TYPE.ERROR,
        render: t("Something went wrong."),
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
      setDeleteModal(false);
      setLoadingListData(false);
      setLoading(false);
    }
  };
  // duplicate Form --------------------------------------------------------



  // Delete Form --------------------------------------------------------
  const onClickDelete = (row: any) => {
    setDeleteNewsLetter(row);
    setDeleteModal(true);
  };

  const handleDeleteNewsLetter = async (data: any) => {
    toastId.current = toast(t("Deleting news letter")+"...", {
      autoClose: false,
      isLoading: true,
    });
    const res = await newsLetterService.delete(deleteNewsLetter?.id);
    if (res.status === "success") {
      setDeleteModal(false);
      getNewsLetterList();
      toast.update(toastId.current, {
        type: toast.TYPE.SUCCESS,
        render: t("News letter deleted successfully"),
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
    } else {
      toast.update(toastId.current, {
        type: toast.TYPE.ERROR,
        render: res?.message,
        autoClose: 5000,
        isLoading: false,
        delay: 500,
      });
    }
  }
  // Delete Form --------------------------------------------------------


  const viewMail = async (data: any) => {
    setOpenTemplateViewer(true);
    setTemplateID(data);
    
  }
  const scheduleMail = (data: any) => {
    setTemplateID(data);
    setScheduleBox(true);
  }

  useEffect(() => {
    setNewsLetterListData([])
    setLoadingListData(true);
  }, [localStorage.getItem("I18N_LANGUAGE")]);

  return (
    <React.Fragment>
      {deleteNewsLetter && (
        <DeleteModal
          recordName={deleteNewsLetter?.title}
          modalTitle={t("News Letter")}
          show={deleteModal}
          onDeleteClick={handleDeleteNewsLetter}
          onCloseClick={() => setDeleteModal(false)}
          loading={loading}
        />
      )}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            breadcrumbTitle=""
            breadcrumbItems={breadcrumbItems}
            endAdornment={
              userProfile.CAN_CREATE ? <Link
                to="../masters/news-letter/new"
                className="btn btn-primary btn-sm waves-effect waves-light btn-label"
              >
                <span className="align-middle material-symbols-outlined fw-light fs-4 label-icon">add</span>{t('Create New News Letter')}
              </Link> : null
            }
          />

          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <DataTable
                    columns={columns}
                    products={newsLetterListData}
                    datatableOptions={datatableOptions}
                    filters={[]}
                    onTableChange={onTableChange}
                    loadingListData={loadingListData}
                    clearFilter={clearFilter}
                    settingTableName="newsletter_table"
                    slug="masters"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Drawer
        title={t("News Letter")}
        open={openTemplateViewer}
        onClose={() => setOpenTemplateViewer((state) => !state)}
        footer={
          <Button
            color="primary"
            style={{ margin: "16px" }}
            onClick={() => setOpenTemplateViewer((state) => !state)}
          >
            Close
          </Button>
        }
        fullWidth
      >
        <ViewTemplate
          id={templateID.id}
          news_letter_id={templateID.news_letter_id}
        />
      </Drawer>
      <Drawer
        title={templateID?.title}
        open={scheduleBox}
        onClose={() => setScheduleBox((state) => !state)}
        footer={
          <Button
            color="primary"
            style={{ margin: "16px" }}
            onClick={() => setScheduleBox((state) => !state)}
          >
            Close
          </Button>
        }
      >
        <Schedule
          data={templateID}
        />
      </Drawer>
    </React.Fragment>
  );
};

export default NewsLetterList;
